import React, { PureComponent, ReactNode } from "react";
import styled from "styled-components";

const StyledAvisVerifies = styled.div`
  @media (max-width: 506px) {
    height: 320px;
  }
`;

export interface IProps {
  className?: string;
}

type IDefaultProps = Required<Pick<IProps, "className">>;

class AvisVerifies extends PureComponent<IProps, {}, IDefaultProps> {
  public static defaultProps: IDefaultProps = {
    className: "",
  };

  public render(): ReactNode {
    return (
      <StyledAvisVerifies
        className={this.props.className}
        dangerouslySetInnerHTML={{
          __html: `
          <iframe
            frameborder="0"
            height="100%"
            id="AV_widget_iframe"
            src="//cl.avis-verifies.com/fr/cache/b/6/5/b659fe0a-6be4-f604-218a-0d8552e9fd5d/widget4/b659fe0a-6be4-f604-218a-0d8552e9fd5dhorizontal_index.html"
            width="100%"
        />
        `,
        }}
      />
    );
  }
}

export default AvisVerifies;
